// Test IDs for the public landing / entry page (05.8).

export const LANDING = {
        page: 'landing-page',
        brand: 'landing-brand',
        hero: 'landing-hero',
        ctaWhatsapp: 'landing-cta-whatsapp',
        ctaLogin: 'landing-cta-login',
        ctaLoginHero: 'landing-cta-login-hero',
};
